import { jsonldReviewAuthor } from './JsonldStore';

export const updateJsonldReviewAuthor = (value) => jsonldReviewAuthor.update((oldValue) => value);
